export default __webpack_public_path__ + "static/image10-f7c7f8f7747887eafc627fa0af67d056.gif";